import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * 类名合并工具（基于 clsx 和 tailwind-merge）
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
